import React from 'react';

export default function HRCopilotProductivity() {
  return (
    <div className="hrcopilot-productivity-wrapper">
      <style>{`
        .hrcopilot-productivity-wrapper {
          max-width: 1400px;
          margin: 0 auto;
          padding: 80px 40px;
          background-color: #f0f0f0;
        }

        .hrcopilot-productivity-header {
          text-align: center;
          margin-bottom: 60px;
        }

        .hrcopilot-productivity-title {
          font-size: 4rem;
          font-weight: 700;
          font-style: italic;
          color: #1a1a1a;
          line-height: 1.2;
          font-family: 'Brush Script MT', cursive, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        .hrcopilot-productivity-highlight {
          position: relative;
          display: inline-block;
        }

        .hrcopilot-productivity-highlight::after {
          content: '';
          position: absolute;
          bottom: 8px;
          left: 0;
          width: 100%;
          height: 16px;
          background-color: #fdb755;
          z-index: -1;
          border-radius: 4px;
        }

        .hrcopilot-productivity-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 24px;
        }

        .hrcopilot-productivity-frame {
          background-color: white;
          border-radius: 12px;
          padding: 24px;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
          overflow: hidden;
        }

        .hrcopilot-productivity-frame1 {
          grid-column: 1;
          grid-row: 1 / 3;
        }

        .hrcopilot-productivity-frame2 {
          grid-column: 2;
          grid-row: 1;
        }

        .hrcopilot-productivity-frame3 {
          grid-column: 2;
          grid-row: 2;
        }

        .hrcopilot-productivity-frame4 {
          grid-column: 1 / 3;
          grid-row: 3;
        }

        .hrcopilot-frame-activities {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .hrcopilot-frame-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 16px;
          background-color: #e8eaf6;
          border-radius: 8px;
          margin-bottom: 16px;
        }

        .hrcopilot-frame-icons {
          display: flex;
          gap: 12px;
        }

        .hrcopilot-frame-icon {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background-color: #ff6b6b;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 0.8rem;
          font-weight: 700;
        }

        .hrcopilot-activity-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px;
          border-radius: 8px;
          transition: background-color 0.2s ease;
        }

        .hrcopilot-activity-item:hover {
          background-color: #f5f5f5;
        }

        .hrcopilot-activity-icon {
          width: 40px;
          height: 40px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.3rem;
        }

        .hrcopilot-activity-info {
          flex: 1;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .hrcopilot-activity-name {
          font-size: 0.95rem;
          font-weight: 600;
          color: #1a1a1a;
        }

        .hrcopilot-activity-stats {
          display: flex;
          gap: 16px;
          font-size: 0.85rem;
          color: #666;
        }

        .hrcopilot-task-card {
          padding: 16px;
          border-left: 4px solid #4caf50;
          margin-bottom: 12px;
          background-color: #f9f9f9;
          border-radius: 4px;
        }

        .hrcopilot-task-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
        }

        .hrcopilot-task-title {
          font-size: 1.1rem;
          font-weight: 700;
          color: #1a1a1a;
        }

        .hrcopilot-task-count {
          font-size: 1.5rem;
          font-weight: 700;
          color: #4caf50;
        }

        .hrcopilot-task-progress {
          width: 100%;
          height: 8px;
          background-color: #e0e0e0;
          border-radius: 4px;
          overflow: hidden;
        }

        .hrcopilot-task-progress-fill {
          height: 100%;
          background: linear-gradient(to right, #4caf50 0%, #4caf50 70%, #fdb755 70%, #fdb755 100%);
        }

        .hrcopilot-project-card {
          padding: 20px;
          background-color: #fff9f0;
          border-radius: 8px;
        }

        .hrcopilot-project-title {
          font-size: 1.2rem;
          font-weight: 700;
          color: #1a1a1a;
          margin-bottom: 12px;
        }

        .hrcopilot-project-tags {
          display: flex;
          gap: 8px;
          margin-bottom: 12px;
          flex-wrap: wrap;
        }

        .hrcopilot-project-tag {
          padding: 6px 12px;
          border-radius: 16px;
          font-size: 0.85rem;
          font-weight: 600;
        }

        .hrcopilot-tag-pink {
          background-color: #fce4ec;
          color: #c2185b;
        }

        .hrcopilot-tag-gray {
          background-color: #f5f5f5;
          color: #616161;
        }

        .hrcopilot-tag-cyan {
          background-color: #e0f7fa;
          color: #00838f;
        }

        .hrcopilot-project-meta {
          display: flex;
          gap: 12px;
          align-items: center;
          font-size: 0.9rem;
          color: #666;
        }

        .hrcopilot-project-avatars {
          display: flex;
          margin-left: auto;
        }

        .hrcopilot-avatar {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: 2px solid white;
          margin-left: -8px;
        }

        .hrcopilot-avatar:first-child {
          margin-left: 0;
        }

        .hrcopilot-user-search {
          padding: 20px;
        }

        .hrcopilot-search-box {
          width: 100%;
          padding: 12px 16px;
          border: 2px solid #e0e0e0;
          border-radius: 8px;
          font-size: 1rem;
          margin-bottom: 16px;
        }

        .hrcopilot-user-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .hrcopilot-user-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px;
          border-radius: 8px;
          transition: background-color 0.2s ease;
          cursor: pointer;
        }

        .hrcopilot-user-item:hover {
          background-color: #f5f5f5;
        }

        .hrcopilot-user-avatar {
          width: 48px;
          height: 48px;
          border-radius: 8px;
          background: linear-gradient(135deg, #fdb755 0%, #ff9800 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 700;
          font-size: 1.2rem;
        }

        .hrcopilot-user-details {
          flex: 1;
        }

        .hrcopilot-user-name {
          font-size: 1rem;
          font-weight: 600;
          color: #1a1a1a;
          margin-bottom: 4px;
        }

        .hrcopilot-user-email {
          font-size: 0.85rem;
          color: #666;
        }

        .hrcopilot-user-status {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background-color: #4caf50;
        }

        @media (max-width: 1024px) {
          .hrcopilot-productivity-grid {
            grid-template-columns: 1fr;
          }

          .hrcopilot-productivity-frame1,
          .hrcopilot-productivity-frame2,
          .hrcopilot-productivity-frame3,
          .hrcopilot-productivity-frame4 {
            grid-column: 1;
            grid-row: auto;
          }

          .hrcopilot-productivity-title {
            font-size: 3rem;
          }
        }

        @media (max-width: 768px) {
          .hrcopilot-productivity-wrapper {
            padding: 60px 20px;
          }

          .hrcopilot-productivity-title {
            font-size: 2.5rem;
          }

          .hrcopilot-productivity-frame {
            padding: 16px;
          }
        }
      `}</style>

      <div className="hrcopilot-productivity-header">
        <h2 className="hrcopilot-productivity-title">
          Optimized for <span className="hrcopilot-productivity-highlight">productivity</span>
        </h2>
      </div>

      <div className="hrcopilot-productivity-grid">
        {/* Frame 1: Activity List */}
        <div className="hrcopilot-productivity-frame hrcopilot-productivity-frame1">
          <div className="hrcopilot-frame-header">
            <span style={{fontWeight: 600}}>Activities</span>
            <div className="hrcopilot-frame-icons">
              <div className="hrcopilot-frame-icon">1</div>
              <div className="hrcopilot-frame-icon">2</div>
            </div>
          </div>

          <div className="hrcopilot-frame-activities">
            <div className="hrcopilot-activity-item">
              <div className="hrcopilot-activity-icon" style={{background: 'linear-gradient(135deg, #ff6b6b, #ff8e8e)'}}>
                📅
              </div>
              <div className="hrcopilot-activity-info">
                <div>
                  <div className="hrcopilot-activity-name">Event</div>
                  <div className="hrcopilot-activity-stats">
                    <span>0 Late</span>
                    <span>1 Today</span>
                    <span>2 Future</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="hrcopilot-activity-item">
              <div className="hrcopilot-activity-icon" style={{background: 'linear-gradient(135deg, #fdb755, #ff9800)'}}>
                ⏰
              </div>
              <div className="hrcopilot-activity-info">
                <div>
                  <div className="hrcopilot-activity-name">Time Off</div>
                  <div className="hrcopilot-activity-stats">
                    <span>0 Late</span>
                    <span>1 Today</span>
                    <span>0 Future</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="hrcopilot-activity-item">
              <div className="hrcopilot-activity-icon" style={{background: 'linear-gradient(135deg, #4dd4ac, #26a69a)'}}>
                📊
              </div>
              <div className="hrcopilot-activity-info">
                <div>
                  <div className="hrcopilot-activity-name">Time Off Allocation</div>
                  <div className="hrcopilot-activity-stats">
                    <span>0 Late</span>
                    <span>6 Today</span>
                    <span>0 Future</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="hrcopilot-activity-item">
              <div className="hrcopilot-activity-icon" style={{background: 'linear-gradient(135deg, #5c6bc0, #3f51b5)'}}>
                📝
              </div>
              <div className="hrcopilot-activity-info">
                <div>
                  <div className="hrcopilot-activity-name">Journal Entry</div>
                  <div className="hrcopilot-activity-stats">
                    <span>0 Late</span>
                    <span>2 Today</span>
                    <span>4 Future</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="hrcopilot-activity-item">
              <div className="hrcopilot-activity-icon" style={{background: 'linear-gradient(135deg, #26a69a, #00897b)'}}>
                💎
              </div>
              <div className="hrcopilot-activity-info">
                <div>
                  <div className="hrcopilot-activity-name">Lead/Opportunity</div>
                  <div className="hrcopilot-activity-stats">
                    <span>1 Late</span>
                    <span>1 Today</span>
                    <span>7 Future</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="hrcopilot-activity-item">
              <div className="hrcopilot-activity-icon" style={{background: 'linear-gradient(135deg, #4dd4ac, #26a69a)'}}>
                🎫
              </div>
              <div className="hrcopilot-activity-info">
                <div>
                  <div className="hrcopilot-activity-name">Helpdesk Ticket</div>
                  <div className="hrcopilot-activity-stats">
                    <span>1 Late</span>
                    <span>1 Today</span>
                    <span>1 Future</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="hrcopilot-activity-item">
              <div className="hrcopilot-activity-icon" style={{background: 'linear-gradient(135deg, #42a5f5, #1976d2)'}}>
                👤
              </div>
              <div className="hrcopilot-activity-info">
                <div>
                  <div className="hrcopilot-activity-name">Applicant</div>
                  <div className="hrcopilot-activity-stats">
                    <span>6 Late</span>
                    <span>1 Today</span>
                    <span>0 Future</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Frame 2: Task Progress */}
        <div className="hrcopilot-productivity-frame hrcopilot-productivity-frame2">
          <div className="hrcopilot-task-card">
            <div className="hrcopilot-task-header">
              <h3 className="hrcopilot-task-title">Final Check</h3>
              <span className="hrcopilot-task-count">2</span>
            </div>
            <div className="hrcopilot-task-progress">
              <div className="hrcopilot-task-progress-fill" style={{width: '85%'}}></div>
            </div>
          </div>

          <div className="hrcopilot-project-card">
            <h3 className="hrcopilot-project-title">Bathroom</h3>
            <div className="hrcopilot-project-tags">
              <span className="hrcopilot-project-tag hrcopilot-tag-pink">1st floor</span>
              <span className="hrcopilot-project-tag hrcopilot-tag-gray">Design</span>
              <span className="hrcopilot-project-tag hrcopilot-tag-cyan">Sanitary plumbing</span>
            </div>
            <div className="hrcopilot-project-meta">
              <span>⭐</span>
              <span>⏱️</span>
              <span>01:00</span>
              <div className="hrcopilot-project-avatars">
                <div className="hrcopilot-avatar"></div>
                <div className="hrcopilot-avatar"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Frame 3: Plans */}
        <div className="hrcopilot-productivity-frame hrcopilot-productivity-frame3">
          <h3 className="hrcopilot-project-title">Plans</h3>
          <img 
            src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=600&h=400&fit=crop&q=80" 
            alt="Architectural floor plan"
            style={{width: '100%', height: '280px', objectFit: 'cover', borderRadius: '8px'}}
          />
          <div className="hrcopilot-project-meta" style={{marginTop: '12px'}}>
            <span>⭐</span>
            <span>⏱️</span>
            <span>01:00</span>
            <div className="hrcopilot-project-avatars">
              <div className="hrcopilot-avatar"></div>
            </div>
          </div>
        </div>

        {/* Frame 4: User Search */}
        <div className="hrcopilot-productivity-frame hrcopilot-productivity-frame4">
          <div className="hrcopilot-user-search">
            <input 
              type="text" 
              placeholder="🔍 Search for a user..." 
              className="hrcopilot-search-box"
            />

            <div className="hrcopilot-user-list">
              <div className="hrcopilot-user-item">
                <div className="hrcopilot-user-avatar">LP</div>
                <div className="hrcopilot-user-details">
                  <div className="hrcopilot-user-name">Laurie Poiret</div>
                  <div className="hrcopilot-user-email">laurie.poiret@odoo.com</div>
                </div>
                <div className="hrcopilot-user-status"></div>
              </div>

              <div className="hrcopilot-user-item">
                <div className="hrcopilot-user-avatar" style={{background: 'linear-gradient(135deg, #667eea, #764ba2)'}}>MD</div>
                <div className="hrcopilot-user-details">
                  <div className="hrcopilot-user-name">Maggie Davidson</div>
                  <div className="hrcopilot-user-email">maggie.davidson@odoo.com</div>
                </div>
                <div className="hrcopilot-user-status" style={{backgroundColor: '#bdbdbd'}}></div>
              </div>

              <div className="hrcopilot-user-item">
                <div className="hrcopilot-user-avatar" style={{background: 'linear-gradient(135deg, #5c6bc0, #3f51b5)'}}>MD</div>
                <div className="hrcopilot-user-details">
                  <div className="hrcopilot-user-name">Marc Demo</div>
                  <div className="hrcopilot-user-email">marc.demo@odoo.com</div>
                </div>
                <div className="hrcopilot-user-status" style={{backgroundColor: '#bdbdbd'}}></div>
              </div>

              <div className="hrcopilot-user-item">
                <div className="hrcopilot-user-avatar" style={{background: 'linear-gradient(135deg, #4caf50, #388e3c)'}}>MA</div>
                <div className="hrcopilot-user-details">
                  <div className="hrcopilot-user-name">Mitchell Admin</div>
                  <div className="hrcopilot-user-email">mitchell.admin@odoo.com</div>
                </div>
                <div className="hrcopilot-user-status"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}